import config from '../config';

export const createPath = (...args: string[]) =>
  args.join('/').replace(/([^:]\/)\/+/g, '$1');

export const getConsumerUrl = (path: string) => {
  return createPath(config.env.CONSUMER_APP_HOST, path);
};

export const getMarketingUrl = (path: string) => {
  return createPath(config.env.MARKETING_APP_HOST, path);
};
